import React, { useContext, useCallback } from 'react';
import { Translator } from 'ggApp/modules/translator/components';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import Arrow from 'ggApp/shared/icons/Arrow';
import { Plan, Length, Btn } from './styles';

interface PlanSelectorProps {
    itemId: string | number;
    currentPlanLength: number | string;
    plans?: Array<{ minimum_term_months: number }>;
}

export const PlanSelector = ({
    itemId,
    currentPlanLength,
    plans,
}: PlanSelectorProps): JSX.Element => {
    const { customizePlanFlag, send } = useContext(OrderContext);

    const planIndex = plans && plans.findIndex((i) => i.minimum_term_months === currentPlanLength);

    const onPrev = useCallback(() => {
        send('UPDATE_LINE_ITEM', {
            item: {
                id: itemId,
                committed_months: plans[planIndex - 1].minimum_term_months,
            },
        });
    }, [itemId, send, planIndex, plans]);

    const onNext = useCallback(() => {
        send('UPDATE_LINE_ITEM', {
            item: {
                id: itemId,
                committed_months: plans[planIndex + 1].minimum_term_months,
            },
        });
    }, [itemId, send, planIndex, plans]);

    const isOneMonthPlan = currentPlanLength === 1;

    return (
        <Plan>
            {customizePlanFlag && (planIndex || planIndex === 0) && (
                <Btn type="button" disabled={planIndex === 0} onClick={onPrev} prev>
                    <Arrow />
                </Btn>
            )}

            <Length>
                <Translator
                    withValues={{ count: currentPlanLength }}
                    tk={
                        isOneMonthPlan
                            ? 'PRODUCT_CARD_PLAN_PERIOD_SINGULAR'
                            : 'PRODUCT_CARD_PLAN_PERIOD'
                    }
                />
            </Length>

            {customizePlanFlag && (planIndex || planIndex === 0) && (
                <Btn type="button" disabled={planIndex >= plans.length - 1} onClick={onNext}>
                    <Arrow />
                </Btn>
            )}
        </Plan>
    );
};
